import {
  currentAdPopupResponseSchema,
  type AdPopupSurface,
  type CurrentAdPopupResponse,
} from '@entities/ad-popup';
import { createQuery } from '@shared/lib/query-helpers';

export const adPopupRuntimeKeys = { all: ['ad-popup-runtime'] as const };

export function currentAdPopupQuery(surface: AdPopupSurface, enabled: boolean) {
  return createQuery<CurrentAdPopupResponse>({
    queryKey: [...adPopupRuntimeKeys.all, surface],
    path: '/api/v1/ad-popups/current',
    requestOptions: { params: { surface } },
    schema: currentAdPopupResponseSchema,
    staleTime: 0,
    gcTime: 30_000,
    enabled,
  });
}
